import React from 'react';

// Todo DEVP-140: check use cases and add more props
interface IProps {
	className?: string;
}

export function Divider({ className }: IProps) {
	return (
		<span
			className={[
				className,
				'h-0.5',
				'bg-red-500',
				'w-[100px]',
				'my-4',
			].join(' ')}
		></span>
	);
}
